import { HttpClient } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';

export type TerminalFilterValue = string | number | boolean | string[] | number[];

export interface PosTerminal {
  id?: number;
  serialNumber?: string;
  softwareVersion?: string;
  enabled?: boolean;
  terminalStatus?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PosTerminalDataRequest {
  page: number;
  size: number;
  search: string;
  filters: Record<string, TerminalFilterValue>;
}

export interface PosTerminalPageResponse {
  data: PosTerminal[];
  recordsTotal: number;
  recordsFiltered: number;
  currentPage?: number;
  totalPages?: number;
  totalElements?: number;
}

export interface PosTerminalSaveRequest {
  serialNumber: string;
  softwareVersion: string;
  enabled: boolean;
  terminalStatus: string;
}

export interface PosVirtualTerminal {
  id?: number;
  posTerminalId?: number;
  terminalType?: 'CP' | 'CNP';
  clientId?: number;
  terminalId?: string;
  status?: string;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface PosVirtualTerminalSaveRequest {
  posTerminalId: number | null;
  terminalType: 'CP' | 'CNP';
  clientId: number | null;
  status: string;
  enabled: boolean;
}

export interface PosTerminalPayway {
  id?: number;
  terminalId?: string;
  posVirtualTerminalId?: number;
  posMerchantId?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface PosTerminalPaywaySaveRequest {
  terminalId: string;
  posVirtualTerminalId: number | null;
  posMerchantId: number | null;
}

export interface PosTerminalGP {
  id?: number;
  posVirtualTerminalId?: number;
  submerchantDataId?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface PosTerminalGPSaveRequest {
  posVirtualTerminalId: number | null;
  submerchantDataId: number | null;
}

export interface PosVirtualTerminalMedioPago {
  id?: number;
  pos_virutal_terminal_id?: number;
  medio_pago_id?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface PosVirtualTerminalMedioPagoSaveRequest {
  pos_virutal_terminal_id: number | null;
  medio_pago_id: number | null;
}

export interface PosInstallments {
  id?: number;
  posMerchantConditionFeeId?: number;
  installmentFactor?: number;
  installmentNumber?: number;
  start?: string;
  enable?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface PosInstallmentsSaveRequest {
  posMerchantConditionFeeId: number | null;
  installmentFactor: number | null;
  installmentNumber: number | null;
  start: string;
  enable: boolean;
}

export interface PosInstallmentsPlan {
  id?: number;
  posMerchantConditionFeeId?: number;
  description?: string;
  internacional?: boolean;
  start?: string;
  ending?: string;
  enabled?: boolean;
  clientFinancialCharge?: boolean;
  surchargePercentage?: number;
  maxFinancingAmount?: number;
  binList?: string[];
  dayList?: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface PosInstallmentsPlanSaveRequest {
  posMerchantConditionFeeId: number | null;
  description: string;
  internacional: boolean;
  start: string;
  ending: string;
  enabled: boolean;
  clientFinancialCharge: boolean;
  surchargePercentage: number | null;
  maxFinancingAmount: number | null;
  binList: string[];
  dayList: string[];
}

export interface PosInstallmentsPlanFactor {
  id?: number;
  posInstallmentsPlanId?: number;
  installmentFactor?: number;
  installmentNumber?: number;
  displayText?: string;
  enabled?: boolean;
}

export interface PosInstallmentsPlanFactorSaveRequest {
  posInstallmentsPlanId: number | null;
  installmentFactor: number | null;
  installmentNumber: number | null;
  displayText: string;
  enabled: boolean;
}

export interface PosClientInstallmentsPlan {
  id?: number;
  clientId?: number;
  posInstallmentsPlanId?: number;
  enabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface PosClientInstallmentsPlanSaveRequest {
  clientId: number | null;
  posInstallmentsPlanId: number | null;
  enabled: boolean;
}

export interface PosMerchantId {
  id?: number;
  clientId?: number;
  merchantId?: string;
  enabled?: boolean;
  descripcion?: string;
  mcc?: string;
  cardBrand?: string;
  paymentProcessType?: string;
  bankId?: number;
  acquirer?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PosMerchantIdSaveRequest {
  clientId: number | null;
  merchantId: string;
  enabled: boolean;
  descripcion: string;
  mcc: string;
  cardBrand: string;
  paymentProcessType: string;
  bankId: number | null;
  acquirer: string;
}

export interface SubmerchantSummary {
  id?: number;
  cuit?: number;
  razonSocial?: string;
  nombreComercial?: string;
  cardNotPresent?: boolean;
  status?: number;
  submerchantId?: string;
  createdAt?: string;
}

export interface Province {
  id: number;
  code: string;
  name: string;
}

export interface Locality {
  id: number;
  name: string;
  postalCode: string;
  provinceCode: string;
}

export interface SubmerchantData {
  softDescriptor?: string;
  clientId?: number;
  idLocalidad?: number;
  provinceId?: number;
  cnp?: boolean;
	CodSubcomercio?: string;
	codSubcomercio?: string;
  mcc: number | null;
  cuit: number | null;
  razonSocial: string;
  nombreComercial: string;
  calleNumero: string;
  codPostal: string;
  localidad: string;
  provincia: string;
	latitudY?: number | null;
	longitudX?: number | null;
	mailComercio: string;
	urlSitioWeb?: string;
	telefono: number | null;
  nombreTitular: string;
  apellidoTitular: string;
  tipoDocumento: number;
  documentoTitular: number | null;
	fechaNacimientoTitular?: string;
  estado: number;
  subcomercioId?: string;
}

export interface SubmerchantSaveRequest {
  submerchantDTO: SubmerchantData;
  cnp: boolean;
  idLocalidad: number | null;
  clientId: number | null;
}

export interface PosMerchantConditionFee {
  id?: number;
  posMerchantId?: number;
  paymentType?: string;
  installmentType?: string;
  tax?: number;
  fee?: number;
  tna?: number;
  bankFee?: number;
  createdAt?: string;
  updatedAt?: string;
}

export interface PosMerchantConditionFeeSaveRequest {
  posMerchantId: number | null;
  paymentType: string;
  installmentType: string;
  tax: number | null;
  fee: number | null;
  tna: number | null;
  bankFee: number | null;
}

export interface TerminalConfigurationSummary {
  terminalId?: number;
  serialNumber?: string;
  softwareVersion?: string;
  terminalStatus?: string;
  terminalEnabled?: boolean;
  virtualTerminalId?: string;
  clientId?: number;
  virtualStatus?: string;
  virtualEnabled?: boolean;
  merchantTerminalCount?: number;
  paywayTerminalIds?: string[];
  updatedAt?: string;
}

export interface SpringPageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
}

@Injectable({ providedIn: 'root' })
export class TerminalManagementApi {
  private readonly terminalUrl = '/management/pos-terminal';
  private readonly merchantIdUrl = '/management/pos-merchant-id';
  private readonly conditionFeeUrl = '/management/pos-merchant-condition-fee';
  private readonly virtualTerminalUrl = '/management/pos-virtual-terminal';
  private readonly virtualTerminalMedioPagoUrl = '/management/pos-virtual-terminal-medio-pago';
  private readonly terminalPaywayUrl = '/management/pos-terminal-payway';
  private readonly terminalGPUrl = '/management/pos-terminal-gp';
  private readonly installmentsUrl = '/management/pos-installments';
  private readonly installmentsPlanUrl = '/management/pos-installments-plan';
  private readonly installmentsPlanFactorUrl = '/management/pos-installments-plan-factor';
  private readonly clientInstallmentsPlanUrl = '/management/pos-client-installments-plan';
  private readonly terminalConfigurationUrl = '/management/terminal-configuration';
  private readonly submerchantUrl = '/management/api/submerchants';

  constructor(private readonly http: HttpClient) {}

  getPosTerminals(request: PosTerminalDataRequest): Observable<PosTerminalPageResponse> {
    return this.http
      .post<PosTerminalPageResponse>(`${this.terminalUrl}/data`, {
        page: Number(request.page ?? 0),
        size: Number(request.size ?? 10),
        search: request.search ?? '',
        filters: request.filters ?? {}
      })
      .pipe(timeout(30000));
  }

  createPosTerminal(request: PosTerminalSaveRequest): Observable<PosTerminal> {
    return this.http.post<PosTerminal>(this.terminalUrl, this.normalizeTerminal(request)).pipe(timeout(30000));
  }

  updatePosTerminal(id: number, request: PosTerminalSaveRequest): Observable<PosTerminal> {
    return this.http.put<PosTerminal>(`${this.terminalUrl}/${id}`, this.normalizeTerminal(request)).pipe(timeout(30000));
  }

  deletePosTerminal(id: number): Observable<void> {
    return this.http.delete<void>(`${this.terminalUrl}/${id}`).pipe(timeout(30000));
  }

  getPosTerminalsByIds(ids: number[]): Observable<SpringPageResponse<PosTerminal>> {
    const params = new HttpParams()
      .set('page', '0')
      .set('size', String(ids.length))
      .set('search', `id=in=(${ids.join(',')})`);
    return this.http.get<SpringPageResponse<PosTerminal>>(this.terminalUrl, { params }).pipe(timeout(30000));
  }

  getAvailablePosTerminals(): Observable<PosTerminal[]> {
    return this.http
      .get<PosTerminal[]>(`${this.virtualTerminalUrl}/available-pos-terminals`)
      .pipe(timeout(30000));
  }

  getVirtualTerminals(page: number, size: number, search: string): Observable<SpringPageResponse<PosVirtualTerminal>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<SpringPageResponse<PosVirtualTerminal>>(this.virtualTerminalUrl, { params }).pipe(timeout(30000));
  }

  createVirtualTerminal(request: PosVirtualTerminalSaveRequest): Observable<PosVirtualTerminal> {
    return this.http
      .post<PosVirtualTerminal>(this.virtualTerminalUrl, this.normalizeVirtualTerminal(request))
      .pipe(timeout(30000));
  }

  updateVirtualTerminal(id: number, request: PosVirtualTerminalSaveRequest): Observable<PosVirtualTerminal> {
    return this.http
      .put<PosVirtualTerminal>(`${this.virtualTerminalUrl}/${id}`, this.normalizeVirtualTerminal(request))
      .pipe(timeout(30000));
  }

  deleteVirtualTerminal(id: number): Observable<void> {
    return this.http.delete<void>(`${this.virtualTerminalUrl}/${id}`).pipe(timeout(30000));
  }

  getVirtualTerminalMedioPagos(
    page: number,
    size: number,
    search: string
  ): Observable<SpringPageResponse<PosVirtualTerminalMedioPago>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http
      .get<SpringPageResponse<PosVirtualTerminalMedioPago>>(this.virtualTerminalMedioPagoUrl, { params })
      .pipe(timeout(30000));
  }

  createVirtualTerminalMedioPago(
    request: PosVirtualTerminalMedioPagoSaveRequest
  ): Observable<PosVirtualTerminalMedioPago> {
    return this.http
      .post<PosVirtualTerminalMedioPago>(this.virtualTerminalMedioPagoUrl, this.normalizeVirtualTerminalMedioPago(request))
      .pipe(timeout(30000));
  }

  updateVirtualTerminalMedioPago(
    id: number,
    request: PosVirtualTerminalMedioPagoSaveRequest
  ): Observable<PosVirtualTerminalMedioPago> {
    return this.http
      .put<PosVirtualTerminalMedioPago>(`${this.virtualTerminalMedioPagoUrl}/${id}`, this.normalizeVirtualTerminalMedioPago(request))
      .pipe(timeout(30000));
  }

  deleteVirtualTerminalMedioPago(id: number): Observable<void> {
    return this.http.delete<void>(`${this.virtualTerminalMedioPagoUrl}/${id}`).pipe(timeout(30000));
  }

  getTerminalPayways(page: number, size: number, search: string): Observable<SpringPageResponse<PosTerminalPayway>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<SpringPageResponse<PosTerminalPayway>>(this.terminalPaywayUrl, { params }).pipe(timeout(30000));
  }

  createTerminalPayway(request: PosTerminalPaywaySaveRequest): Observable<PosTerminalPayway> {
    return this.http
      .post<PosTerminalPayway>(this.terminalPaywayUrl, this.normalizeTerminalPayway(request))
      .pipe(timeout(30000));
  }

  updateTerminalPayway(id: number, request: PosTerminalPaywaySaveRequest): Observable<PosTerminalPayway> {
    return this.http
      .put<PosTerminalPayway>(`${this.terminalPaywayUrl}/${id}`, this.normalizeTerminalPayway(request))
      .pipe(timeout(30000));
  }

  deleteTerminalPayway(id: number): Observable<void> {
    return this.http.delete<void>(`${this.terminalPaywayUrl}/${id}`).pipe(timeout(30000));
  }

  getTerminalGPs(page: number, size: number, search: string): Observable<SpringPageResponse<PosTerminalGP>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<SpringPageResponse<PosTerminalGP>>(this.terminalGPUrl, { params }).pipe(timeout(30000));
  }

  createTerminalGP(request: PosTerminalGPSaveRequest): Observable<PosTerminalGP> {
    return this.http.post<PosTerminalGP>(this.terminalGPUrl, this.normalizeTerminalGP(request)).pipe(timeout(30000));
  }

  updateTerminalGP(id: number, request: PosTerminalGPSaveRequest): Observable<PosTerminalGP> {
    return this.http.put<PosTerminalGP>(`${this.terminalGPUrl}/${id}`, this.normalizeTerminalGP(request)).pipe(timeout(30000));
  }

  removeTerminalGPSubmerchant(id: number): Observable<PosTerminalGP> {
    return this.http.put<PosTerminalGP>(`${this.terminalGPUrl}/${id}/remove-submerchant`, {}).pipe(timeout(30000));
  }

  deleteTerminalGP(id: number): Observable<void> {
    return this.http.delete<void>(`${this.terminalGPUrl}/${id}`).pipe(timeout(30000));
  }

  getInstallments(page: number, size: number, search: string): Observable<SpringPageResponse<PosInstallments>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<SpringPageResponse<PosInstallments>>(this.installmentsUrl, { params }).pipe(timeout(30000));
  }

  createInstallment(request: PosInstallmentsSaveRequest): Observable<void> {
    return this.http
      .post<void>(this.installmentsUrl, [this.normalizeInstallment(request)])
      .pipe(timeout(30000));
  }

  updateInstallment(id: number, request: PosInstallmentsSaveRequest): Observable<PosInstallments> {
    return this.http
      .put<PosInstallments>(`${this.installmentsUrl}/${id}`, this.normalizeInstallment(request))
      .pipe(timeout(30000));
  }

  deleteInstallment(id: number): Observable<void> {
    return this.http.delete<void>(`${this.installmentsUrl}/${id}`).pipe(timeout(30000));
  }

  getInstallmentsPlans(page: number, size: number, search: string): Observable<SpringPageResponse<PosInstallmentsPlan>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<SpringPageResponse<PosInstallmentsPlan>>(this.installmentsPlanUrl, { params }).pipe(timeout(30000));
  }

  getInstallmentsPlan(id: number): Observable<PosInstallmentsPlan> {
    return this.http.get<PosInstallmentsPlan>(`${this.installmentsPlanUrl}/${id}`).pipe(timeout(30000));
  }

  createInstallmentsPlan(request: PosInstallmentsPlanSaveRequest): Observable<PosInstallmentsPlan> {
    return this.http
      .post<PosInstallmentsPlan>(this.installmentsPlanUrl, this.normalizeInstallmentsPlan(request))
      .pipe(timeout(30000));
  }

  updateInstallmentsPlan(id: number, request: PosInstallmentsPlanSaveRequest): Observable<PosInstallmentsPlan> {
    return this.http
      .put<PosInstallmentsPlan>(`${this.installmentsPlanUrl}/${id}`, this.normalizeInstallmentsPlan(request))
      .pipe(timeout(30000));
  }

  deleteInstallmentsPlan(id: number): Observable<void> {
    return this.http.delete<void>(`${this.installmentsPlanUrl}/${id}`).pipe(timeout(30000));
  }

  getInstallmentsPlanFactors(
    page: number,
    size: number,
    search: string
  ): Observable<SpringPageResponse<PosInstallmentsPlanFactor>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http
      .get<SpringPageResponse<PosInstallmentsPlanFactor>>(this.installmentsPlanFactorUrl, { params })
      .pipe(timeout(30000));
  }

  createInstallmentsPlanFactor(request: PosInstallmentsPlanFactorSaveRequest): Observable<void> {
    return this.http
      .post<void>(this.installmentsPlanFactorUrl, [this.normalizeInstallmentsPlanFactor(request)])
      .pipe(timeout(30000));
  }

  updateInstallmentsPlanFactor(
    id: number,
    request: PosInstallmentsPlanFactorSaveRequest
  ): Observable<PosInstallmentsPlanFactor> {
    return this.http
      .put<PosInstallmentsPlanFactor>(`${this.installmentsPlanFactorUrl}/${id}`, this.normalizeInstallmentsPlanFactor(request))
      .pipe(timeout(30000));
  }

  deleteInstallmentsPlanFactor(id: number): Observable<void> {
    return this.http.delete<void>(`${this.installmentsPlanFactorUrl}/${id}`).pipe(timeout(30000));
  }

  getClientInstallmentsPlans(
    page: number,
    size: number,
    search: string
  ): Observable<SpringPageResponse<PosClientInstallmentsPlan>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http
      .get<SpringPageResponse<PosClientInstallmentsPlan>>(this.clientInstallmentsPlanUrl, { params })
      .pipe(timeout(30000));
  }

  createClientInstallmentsPlan(
    request: PosClientInstallmentsPlanSaveRequest
  ): Observable<PosClientInstallmentsPlan> {
    return this.http
      .post<PosClientInstallmentsPlan>(this.clientInstallmentsPlanUrl, this.normalizeClientInstallmentsPlan(request))
      .pipe(timeout(30000));
  }

  updateClientInstallmentsPlan(
    id: number,
    request: PosClientInstallmentsPlanSaveRequest
  ): Observable<PosClientInstallmentsPlan> {
    return this.http
      .put<PosClientInstallmentsPlan>(
        `${this.clientInstallmentsPlanUrl}/${id}`,
        this.normalizeClientInstallmentsPlan(request)
      )
      .pipe(timeout(30000));
  }

  deleteClientInstallmentsPlan(id: number): Observable<void> {
    return this.http.delete<void>(`${this.clientInstallmentsPlanUrl}/${id}`).pipe(timeout(30000));
  }

  getMerchantIds(page: number, size: number, search: string): Observable<SpringPageResponse<PosMerchantId>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<SpringPageResponse<PosMerchantId>>(this.merchantIdUrl, { params }).pipe(timeout(30000));
  }

  createMerchantId(request: PosMerchantIdSaveRequest): Observable<PosMerchantId> {
    return this.http.post<PosMerchantId>(this.merchantIdUrl, this.normalizeMerchantId(request)).pipe(timeout(30000));
  }

  updateMerchantId(id: number, request: PosMerchantIdSaveRequest): Observable<PosMerchantId> {
    return this.http.put<PosMerchantId>(`${this.merchantIdUrl}/${id}`, this.normalizeMerchantId(request)).pipe(timeout(30000));
  }

  getConditionFees(page: number, size: number, search: string): Observable<SpringPageResponse<PosMerchantConditionFee>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<SpringPageResponse<PosMerchantConditionFee>>(this.conditionFeeUrl, { params }).pipe(timeout(30000));
  }

  createConditionFee(request: PosMerchantConditionFeeSaveRequest): Observable<PosMerchantConditionFee> {
    return this.http
      .post<PosMerchantConditionFee>(this.conditionFeeUrl, this.normalizeConditionFee(request))
      .pipe(timeout(30000));
  }

  updateConditionFee(id: number, request: PosMerchantConditionFeeSaveRequest): Observable<PosMerchantConditionFee> {
    return this.http
      .put<PosMerchantConditionFee>(`${this.conditionFeeUrl}/${id}`, this.normalizeConditionFee(request))
      .pipe(timeout(30000));
  }

  deleteConditionFee(id: number): Observable<void> {
    return this.http.delete<void>(`${this.conditionFeeUrl}/${id}`).pipe(timeout(30000));
  }

  getTerminalConfigurations(
    page: number,
    size: number,
    search: string
  ): Observable<SpringPageResponse<TerminalConfigurationSummary>> {
    let params = new HttpParams()
      .set('page', String(page ?? 0))
      .set('size', String(size ?? 10))
      .set('sort', 'id,desc');

    if (search) {
      params = params.set('search', search);
    }

    return this.http
      .get<SpringPageResponse<TerminalConfigurationSummary>>(this.terminalConfigurationUrl, { params })
      .pipe(timeout(30000));
  }

  getTerminalConfigurationDetail(serialNumber: string): Observable<Record<string, unknown>> {
    const params = new HttpParams().set('serialNumber', serialNumber);
    return this.http
      .get<Record<string, unknown>>(`${this.terminalConfigurationUrl}/detail`, { params })
      .pipe(timeout(30000));
  }

  getSubmerchants(page: number, size: number, search = 'id=ge=0'): Observable<SpringPageResponse<SubmerchantSummary>> {
    const params = new HttpParams()
      .set('page', String(page))
      .set('size', String(size))
      .set('sort', 'id,desc')
      .set('search', search || 'id=ge=0');
    return this.http.get<SpringPageResponse<SubmerchantSummary>>(`${this.submerchantUrl}/v1`, { params }).pipe(timeout(30000));
  }

  getSubmerchant(id: number): Observable<SubmerchantData> {
    return this.http.get<SubmerchantData>(`${this.submerchantUrl}/v1/${id}`).pipe(timeout(30000));
  }

  saveSubmerchant(request: SubmerchantSaveRequest): Observable<SubmerchantData> {
	const birthDate = request.submerchantDTO.fechaNacimientoTitular;
	const normalized = birthDate && /^\d{4}-\d{2}-\d{2}$/.test(birthDate)
	  ? birthDate.split('-').reverse().join('/')
	  : birthDate;
	return this.http.post<SubmerchantData>(`${this.submerchantUrl}/v1/add`, {
	  ...request,
	  submerchantDTO: { ...request.submerchantDTO, fechaNacimientoTitular: normalized }
	}).pipe(timeout(30000));
  }

  getProvinces(): Observable<Province[]> {
    return this.http.get<Province[]>(`${this.submerchantUrl}/province`).pipe(timeout(30000));
  }

  getCities(provinceId: number): Observable<Locality[]> {
	return this.http.get<Locality[]>(`${this.submerchantUrl}/province/${provinceId}/city`).pipe(timeout(30000));
  }

  private normalizeTerminal(request: PosTerminalSaveRequest): PosTerminalSaveRequest {
    return {
      serialNumber: request.serialNumber.trim(),
      softwareVersion: request.softwareVersion.trim(),
      enabled: Boolean(request.enabled),
      terminalStatus: request.terminalStatus
    };
  }

  private normalizeMerchantId(request: PosMerchantIdSaveRequest): PosMerchantIdSaveRequest {
    return {
      clientId: request.clientId !== null ? Number(request.clientId) : null,
      merchantId: request.merchantId.trim(),
      enabled: Boolean(request.enabled),
      descripcion: request.descripcion.trim(),
      mcc: request.mcc.trim(),
      cardBrand: request.cardBrand,
      paymentProcessType: request.paymentProcessType,
      bankId: request.bankId !== null ? Number(request.bankId) : null,
      acquirer: request.acquirer
    };
  }

  private normalizeConditionFee(request: PosMerchantConditionFeeSaveRequest): PosMerchantConditionFeeSaveRequest {
    return {
      posMerchantId: request.posMerchantId !== null ? Number(request.posMerchantId) : null,
      paymentType: request.paymentType,
      installmentType: request.installmentType,
      tax: request.tax !== null ? Number(request.tax) : null,
      fee: request.fee !== null ? Number(request.fee) : null,
      tna: request.tna !== null ? Number(request.tna) : null,
      bankFee: request.bankFee !== null ? Number(request.bankFee) : null
    };
  }

  private normalizeVirtualTerminal(request: PosVirtualTerminalSaveRequest): PosVirtualTerminalSaveRequest {
    return {
      posTerminalId: request.terminalType === 'CP' && request.posTerminalId !== null
        ? Number(request.posTerminalId)
        : null,
      terminalType: request.terminalType,
      clientId: request.clientId !== null ? Number(request.clientId) : null,
      status: request.status,
      enabled: Boolean(request.enabled)
    };
  }

  private normalizeVirtualTerminalMedioPago(
    request: PosVirtualTerminalMedioPagoSaveRequest
  ): PosVirtualTerminalMedioPagoSaveRequest {
    return {
      pos_virutal_terminal_id: request.pos_virutal_terminal_id !== null ? Number(request.pos_virutal_terminal_id) : null,
      medio_pago_id: request.medio_pago_id !== null ? Number(request.medio_pago_id) : null
    };
  }

  private normalizeTerminalPayway(request: PosTerminalPaywaySaveRequest): PosTerminalPaywaySaveRequest {
    return {
      terminalId: request.terminalId.trim(),
      posVirtualTerminalId: request.posVirtualTerminalId !== null ? Number(request.posVirtualTerminalId) : null,
      posMerchantId: request.posMerchantId !== null ? Number(request.posMerchantId) : null
    };
  }

  private normalizeTerminalGP(request: PosTerminalGPSaveRequest): PosTerminalGPSaveRequest {
    return {
      posVirtualTerminalId: request.posVirtualTerminalId !== null ? Number(request.posVirtualTerminalId) : null,
      submerchantDataId: request.submerchantDataId !== null ? Number(request.submerchantDataId) : null
    };
  }

  private normalizeInstallment(request: PosInstallmentsSaveRequest): PosInstallmentsSaveRequest {
    return {
      posMerchantConditionFeeId:
        request.posMerchantConditionFeeId !== null ? Number(request.posMerchantConditionFeeId) : null,
      installmentFactor: request.installmentFactor !== null ? Number(request.installmentFactor) : null,
      installmentNumber: request.installmentNumber !== null ? Number(request.installmentNumber) : null,
      start: request.start,
      enable: Boolean(request.enable)
    };
  }

  private normalizeInstallmentsPlan(request: PosInstallmentsPlanSaveRequest): PosInstallmentsPlanSaveRequest {
    return {
      posMerchantConditionFeeId:
        request.posMerchantConditionFeeId !== null ? Number(request.posMerchantConditionFeeId) : null,
      description: request.description.trim(),
      internacional: Boolean(request.internacional),
      start: request.start,
      ending: request.ending,
      enabled: Boolean(request.enabled),
      clientFinancialCharge: Boolean(request.clientFinancialCharge),
      surchargePercentage: request.surchargePercentage !== null ? Number(request.surchargePercentage) : null,
      maxFinancingAmount: request.maxFinancingAmount !== null ? Number(request.maxFinancingAmount) : null,
      binList: request.binList,
      dayList: request.dayList
    };
  }

  private normalizeInstallmentsPlanFactor(
    request: PosInstallmentsPlanFactorSaveRequest
  ): PosInstallmentsPlanFactorSaveRequest {
    return {
      posInstallmentsPlanId:
        request.posInstallmentsPlanId !== null ? Number(request.posInstallmentsPlanId) : null,
      installmentFactor: request.installmentFactor !== null ? Number(request.installmentFactor) : null,
      installmentNumber: request.installmentNumber !== null ? Number(request.installmentNumber) : null,
      displayText: request.displayText.trim(),
      enabled: Boolean(request.enabled)
    };
  }

  private normalizeClientInstallmentsPlan(
    request: PosClientInstallmentsPlanSaveRequest
  ): PosClientInstallmentsPlanSaveRequest {
    return {
      clientId: request.clientId !== null ? Number(request.clientId) : null,
      posInstallmentsPlanId:
        request.posInstallmentsPlanId !== null ? Number(request.posInstallmentsPlanId) : null,
      enabled: Boolean(request.enabled)
    };
  }
}
